import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  font-size: 1.1rem;
  position:relative;
  background: #4687AB;
  height: ${(props) => (props.extendNav ? "100vh" : '50px')};
  display: flex;
  opacity:${(props) => (props.extendNav ? ".9" : '1')};
  justify-content: space-between;
  padding: 0.5rem calc((100vw - 1000px) / 2);
  z-index: 5;
  position: sticky;
  top: 0;
  @media (min-width:900px) {
    height:50px;
  }
`;

export const NavLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: 1rem;
  padding: 0 1rem;
  height: 100%;
  border-left: solid 1px transparent;
  border-right: solid 1px transparent;
  cursor: pointer;
  &.active {
    color: rgb(16, 74, 132);
  }
  @media (max-width:900px) {
    display:grid;
    place-content:center;
  }
`;

export const NavLogoLink = styled(Link)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: 1rem;
  padding: 0 1rem;
  height: 100%;
  border-left: solid 1px transparent;
  border-right: solid 1px transparent;
  cursor: pointer;
  &.active {
    color: #fff;
  }
  @media (max-width:900px) {
    display:grid;
    place-content:center;
  }
`;

export const Bars = styled(FaBars)`
  display: none;
  color: #fff;
  @media screen and (max-width: 900px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;



export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavBarExtended = styled.div `
  display:grid;
  place-content:center;
  gap:3rem;
  @media (min-width:900px) {
    display:none;
  }
`




export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #CCF6FF;
  padding: 10px 22px;
  color: rgb(16, 74, 132);
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;
  border: solid 1px transparent;
`;

